import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import * as _ from 'lodash-es';

export function doGetPromise(http: HttpClient, url: string, params: any = {}, headers: any = {}) {
    let subscription: any = null;
    const promise: any = new Promise((resolve, reject) => {
        const request$ = http.get(url, { 'params': setParams(params), 'headers': setHeaders(headers) });

        subscription = request$.subscribe(
            (response) => resolve(response),
            (error) => reject(error)
        );
    });

    // Exposing this to be able to cancel in-flight requests
    promise.unsubscribe = () => {
        if (subscription && (typeof subscription.unsubscribe === 'function')) {
            subscription.unsubscribe();
        }
    };

    return promise;
}

export function doDeletePromise(http: HttpClient, url: string, params: any = {}, headers: any = {}) {
    let subscription: any = null;
    const promise: any = new Promise((resolve, reject) => {
        const request$ = http.delete(url, { 'params': setParams(params), 'headers': setHeaders(headers) });

        subscription = request$.subscribe(
            (response) => resolve(response),
            (error) => reject(error)
        );
    });

    // Exposing this to be able to cancel in-flight requests
    promise.unsubscribe = () => {
        if (subscription && (typeof subscription.unsubscribe === 'function')) {
            subscription.unsubscribe();
        }
    };

    return promise;
}

/**
 * DONT USE THIS.  We shouldn't be creating raw query strings for HTTPClient requests.
 * Use filterParams or getParamsFromAllowedKeys instead, and submit the params object.
 * @param params any Map of query string param names and values to consider.
 * @param allowedKeys List of query string param names that should be included
 * @returns string The literal query string, without the question mark prefix.
 */
export function buildQueryString(params: any = {}, allowedKeys: string[] = []) {
    return getParamsFromAllowedKeys(params, allowedKeys).toString();
}

export function setParams (params: any = {}, httpParams?: HttpParams): HttpParams {
    return _.reduce(
        params,
        function(carry: any, val, key) {
            if (val !== null) {
                // Handle array inputs differently
                if (Array.isArray(val)) {
                    if (val.length > 0) {
                        // Set the first value, append the rest
                        // This is what Angular HttpClient API requires.

                        // HttpParams object is immutable, so each call
                        // to set or append returns a new reference.
                        carry = carry.set(key, val[0]);
                        for (let index = 1; index < val.length; index++) {
                            carry = carry.append(key, val[index]);                            
                        }
                        return carry;
                    }
                }
                // Non-array (scalar) values here.
                return carry.set(key, val);
            }
            return carry;
        },
        (httpParams) ? httpParams : new HttpParams()
    );
}

export function getParamsFromAllowedKeys(params: any = {}, allowedKeys: string[] = []) {
    return setParams(
        filterParams(params, allowedKeys)
    );
}

export function filterParams(params: any = {}, allowedKeys: string[] = []) {
    if (!allowedKeys?.length) return params;
    return _.reduce(
        params,
        (carry, value, key) => {
            if (allowedKeys.includes(key)) {
                carry[key] = value;
            }
            return carry;
        },
        {}
    );
}

export function setHeaders (headers: any = {}, httpHeaders?: HttpHeaders): HttpHeaders {
    return _.reduce(
        headers,
        function(carry: any, val, key) {
            if (val !== null) {
                return carry.set(key, val);
            }
            return carry;
        },
        (httpHeaders) ? httpHeaders : new HttpHeaders()
    );
}